/**
 * Constantes de l'application
 *
 * Centralise les valeurs magiques pour une meilleure maintenabilité.
 */

// =============================================================================
// TIMING & DELAYS
// =============================================================================

/** Durée d'affichage des toasts en ms */
export const TOAST_DURATION = 5000;

/** Délai avant affichage des tips contextuels en ms */
export const CONTEXTUAL_TIP_DELAY = 2000;

/** Durée de l'animation de succès en ms */
export const SUCCESS_ANIMATION_DURATION = 1500;

/** Délai de debounce pour la recherche en ms */
export const SEARCH_DEBOUNCE_DELAY = 300;

// =============================================================================
// PAGINATION & LIMITS
// =============================================================================

/** Nombre d'éléments par page par défaut */
export const DEFAULT_PAGE_SIZE = 20;

/** Limite de résultats pour les recherches */
export const SEARCH_RESULTS_LIMIT = 10;

/** Limite de mouvements récents */
export const RECENT_MOVEMENTS_LIMIT = 50;

/** Limite de mouvements par produit */
export const PRODUCT_MOVEMENTS_LIMIT = 20;

/** Limite de produits top */
export const TOP_PRODUCTS_LIMIT = 10;

/** Nombre de jours pour les analytics */
export const ANALYTICS_DAYS = 30;

// =============================================================================
// THRESHOLDS & PERCENTAGES
// =============================================================================

/** Seuil de progression pour couleur jaune (%) */
export const PROGRESS_WARNING_THRESHOLD = 50;

/** Seuil de progression pour couleur bleue (%) */
export const PROGRESS_GOOD_THRESHOLD = 75;

/** Seuil de progression pour couleur verte (%) */
export const PROGRESS_COMPLETE_THRESHOLD = 100;

/** Seuil de limite d'utilisation pour alerte (%) */
export const USAGE_WARNING_THRESHOLD = 80;

/** Seuil de marge bonne (%) */
export const MARGIN_GOOD_THRESHOLD = 70;

/** Seuil de marge moyenne (%) */
export const MARGIN_MEDIUM_THRESHOLD = 50;

/** Valeur maximale pour badge compteur */
export const BADGE_MAX_COUNT = 99;

// =============================================================================
// TIME RANGES
// =============================================================================

/** Heure de début de la matinée */
export const MORNING_START_HOUR = 5;

/** Heure de fin de la matinée / début de l'après-midi */
export const AFTERNOON_START_HOUR = 12;

/** Heure de début de la soirée */
export const EVENING_START_HOUR = 18;

// =============================================================================
// FORMATTING
// =============================================================================

/** Seuil pour affichage en milliers (1K) */
export const THOUSAND = 1000;

/** Seuil pour affichage en millions (1M) */
export const MILLION = 1000000;

// =============================================================================
// DLC / EXPIRATION
// =============================================================================

/** Jours avant expiration pour alerte critique */
export const DLC_CRITICAL_DAYS = 3;

/** Jours avant expiration pour alerte warning */
export const DLC_WARNING_DAYS = 7;

/** Jours avant expiration pour alerte info */
export const DLC_INFO_DAYS = 14;

// =============================================================================
// API
// =============================================================================

/** Timeout par défaut pour les requêtes API en ms */
export const API_TIMEOUT = 30000;

/** Nombre maximum de retries pour les requêtes */
export const MAX_RETRIES = 3;

/** Délai entre les retries en ms */
export const RETRY_DELAY = 1000;

// =============================================================================
// UI
// =============================================================================

/** Taille minimale des touch targets en px (WCAG 2.1 AA) */
export const MIN_TOUCH_TARGET_SIZE = 44;

/** Largeur maximale du contenu principal en px */
export const MAX_CONTENT_WIDTH = 1280;

/** Espacement entre les touch targets en px */
export const TOUCH_SPACING = 12;
